export default {"src":"/_next/static/media/cod.a727ef1d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};